// extracted by mini-css-extract-plugin
export default {"poetrySpot":"LandmarkPoetry_poetrySpot__OcDqN","spotContent":"LandmarkPoetry_spotContent__RH+PM"};